// Single choke point for surfacing runtime/API errors. Currently logs to the
// console in development only; wire a third-party APM (Sentry, Bugsnag, etc.)
// here later without touching every call site.
export const logError = (context, error) => {
    if (process.env.NODE_ENV !== 'production') {
        console.error(`[${context}]`, error);
    }
};
